export default "__VITE_ASSET__DMJNzE9d__"